import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Social Media App",
      description: "A  social media application developed with React Native for the front-end and NodeJ ExpressJS for the back-end with MongoDB databases.The application includes the following features:Create an account, log in, and update user information.Create posts, whether text, images, or videos, and upload the files to S3.Comment on and interact with posts.Follow accounts and communicate with them via messages.Browse posts based on algorithms that display content you're interested in.The application uses caching and queueing to improve performance.",
      imgUrl: require('../assets/img/project/social media/0.png'),
      media:[require('../assets/img/project/social media/0.png'), ],
      url:"https://github.com/layadi-abderaouf/social-platform",
      tags : ["Nodejs", "Express", "MongoDB", "React Native","redis","aws S3"]
    },
    {
      title: "Multi-vendor Marketplace",
      description: "A multi-vendor online store similar to the Salla platform, developed using PHP, Laravel, TailwindCSS, and MySQL.The project contains three parts:/1 Store Control Panel: The project allows anyone to create their own store with a store control panel that enables them to add items, products, and shipping agents, and view orders./2 Store: A store containing products and items, the ability to purchase products using electronic payment or cash on delivery, specify a shipping location, and track order status (shipping, completed)./3 Admin Control Panel: Allows the admin to monitor and control stores, collect fees from store profits, and transfer profits to them.The site includes electronic payments, user verification via phone number, real-time notifications, and the ability to determine a customer's location and calculate shipping costs.",
      imgUrl: require('../assets/img/project/ecommerve/0 (1).png'),
      media:[require('../assets/img/project/ecommerve/1.png'), 
        require('../assets/img/project/ecommerve/2.png'),
        require('../assets/img/project/ecommerve/3.png'),
        require('../assets/img/project/ecommerve/4.png'),
        require('../assets/img/project/ecommerve/5.png'),
      ],
      url:"",
      tags : ["PHP", "Laravel", "MySql", "TailwindCSS","Google maps Api","Payment integration"]
    },
    {
      title: "Advanced Courses Website (Multi-vendor)",
      description: "A website that allows teachers to create, sell, and monetize educational courses. It also allows learners to purchase courses, view them, and earn a certificate upon completion. The website was developed using NodeJS, ExpressJS, ReactJS, and MongoDB databases.This project includes:- Filtered course searches- Purchase courses using payment cards (Stripe API)- Watch purchased course videos, pass their tests, and earn a final certificate- Communicate with the course creator and ask questions in groups- Create an account for teachers- Create and edit courses, add tests, and monetize their sales- Upload course videos",
      imgUrl: require('../assets/img/project/courses/0.png'),
      media:[require('../assets/img/project/courses/1.png'), 
        require('../assets/img/project/courses/2.png'),
        require('../assets/img/project/courses/3.png'),
        require('../assets/img/project/courses/4.png'),
      ],
      url:"https://github.com/layadi-abderaouf/advanced-courses-website",
      tags : ["Nodejs", "React", "MongoDB", "Stripe Payment integration"]
    },
    {
      title: "Phones Ecommerce",
      description: "An online store for selling mobile phones with a control panel developed using JavaScript, NextJS, and MongoDB.This project includes:- A control panel for adding products, uploading images, editing, and deleting them.- The ability to view purchase orders and shipping addresses.- A website for browsing and searching for products using a filtered method - Adding products to the shopping cart.- The ability to purchase products using a stripe payment gateway.",
      imgUrl: require('../assets/img/project/phonestore/0.png'),
      media:[require('../assets/img/project/phonestore/1.png'), 
        require('../assets/img/project/phonestore/2.png'),
       
      ],
      url:"https://github.com/layadi-abderaouf/ecommerce-nextjs",
      tags : ["Nextjs", "JavaScript", "MongoDB", "Stripe Payment integration"]
    },
    {
      title: "Store Managment System",
      description: "A grocery store management system with all the necessary features, such as adding, managing, and selling items, as well as sales and purchase statistics and user permissions. The project was developed using JavaScript, NodeJS, and the MongoDB database. This project includes:- The ability to add, modify, or delete items and their information.- Sending notifications when a specific product runs out.- Recording the sale or purchase of any product using a barcode.- Accurate sales and total profit statistics - Creating accounts and assigning different permissions to each account.- Creating a list of buyers, sellers, and creditors.",
      imgUrl: require('../assets/img/project/cms/0.png'),
      media:[require('../assets/img/project/cms/0.png'), 
        require('../assets/img/project/cms/1.png'),
        require('../assets/img/project/cms/2.png'),
        require('../assets/img/project/cms/3.png'),
       
      ],
      url:"https://github.com/layadi-abderaouf/advanced-CMS-nodejs",
      tags : ["Nextjs", "JavaScript", "MongoDB", "PugJs"]
    },
    {
      title: "Resturant Website",
      description: "A restaurant website and control panel developed using PHP, Laravel, and MySQL databases.This project includes:- A control panel that allows you to add food, upload photos and videos, and edit or delete them.- A website for visitors that allows them to view food types, search for food, and search for prices.",
      imgUrl: require('../assets/img/project/resturant/0 (2).png'),
      media:[require('../assets/img/project/resturant/1.png'), 
        require('../assets/img/project/resturant/0 (2).png'),
        require('../assets/img/project/resturant/2.png'),
       
      ],
      url:"",
      tags : ["PHP", "Laravel", "Mysql"]
    },
   
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div >
                <h2>Projects</h2>
                <p style={{color : "gray"}} >Check out some of the projects I've developed..</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                 
                  <Tab.Content id="slideInUp" >
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                   
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
